<div class="gw-w-full gw-max-w-8xl">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="gw-space-y-6">
    <!-- Dynamic component container -->
    <div #componentContainer class="gw-p-x-large"></div>

    <!-- Standard action buttons -->
    <div class="gw-flex gw-justify-end gw-gap-3" *ngIf="showButtons">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
